import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import RoutesApp from './routes';
import { AuthProvider } from './contexts/auth';
import { FriendsProvider } from './contexts/friends';
import { TimesProvider } from './contexts/timesContext';
import { NotificationsProvider } from './contexts/notifications';
import './App.css';
import './styles/pwa-optimizations.css';
import { Toaster } from 'react-hot-toast';
import InstallPWA from './components/InstallPWA';
import SessionStatusIndicator from './components/SessionStatusIndicator';
import { AdminProvider } from './contexts/admin';
import AppSplashScreen from './components/AppSplashScreen';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  useEffect(() => {
    // Função para verificar e aplicar atualizações do Service Worker
    const checkForUpdates = () => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(registration => {
          registration.update();
        });
      }
    };

    // Verifica atualizações quando o app é focado
    window.addEventListener('focus', checkForUpdates);
    
    // Verifica atualizações a cada 5 minutos em desenvolvimento
    if (process.env.NODE_ENV === 'development') {
      const interval = setInterval(checkForUpdates, 5 * 60 * 1000);
      return () => {
        clearInterval(interval);
        window.removeEventListener('focus', checkForUpdates);
      };
    }

    return () => window.removeEventListener('focus', checkForUpdates);
  }, []);

  return (
    <BrowserRouter>
      <AppSplashScreen>
        <ErrorBoundary>
          <AuthProvider>
            <NotificationsProvider>
              <AdminProvider>
                <FriendsProvider>
                  <TimesProvider>
                    <RoutesApp />
                    <SessionStatusIndicator />
                    <Toaster
                      position="bottom-center"
                      toastOptions={{
                        duration: 3000,
                        style: { background: '#333', color: '#fff' },
                        success: { style: { background: 'green' } },
                        error: { style: { background: 'red' } },
                      }}
                    />
                    <InstallPWA />
                  </TimesProvider>
                </FriendsProvider>
              </AdminProvider>
            </NotificationsProvider>
          </AuthProvider>
        </ErrorBoundary>
      </AppSplashScreen>
    </BrowserRouter>
  );
}

export default App;
